export default {
  trends: {
    filters: {
      title: "Filtres",
      trends: "Tendances",
      allTrends: "Toutes les tendances",
      displayGames: "Afficher les matchs",
      alternateLines: "Lignes alternatives",
    },
    list: {
      empty: {
        noPropsAvailable: "Aucune prop disponible",
        noTrendsAvailableYet: "Aucune tendance disponible pour le moment",
        needsThreeGamesMinimum: "Minimum de 3 matchs requis",
        pendingOddsCheckBack: "Cotes en attente. Revenez plus tard.",
      },
      preview: {
        comboTrendPreview: "Aperçu de combo",
        tryLinematePlus: "Essayez Linemate+",
      },
      actions: {
        addAllLegsToMyPicks: "Ajouter toutes les legs à Mes picks",
      },
    },
    cheatsheet: {
      title: "Cheatsheet",
      separator: {
        noLongerHundredPercent: "PLUS 100% SOUS CETTE LIGNE",
      },
    },
    details: {
      labels: {
        trendsInThisParlay: "Tendances dans ce parlay",
        straights: "Simples",
        all: "Tout",
        hitRates: "Taux de réussite",
        perGame: "Par match",
        against: "contre",
        rank: "Classement",
        pitcher: "Lanceur",
        handedness: "Main dominante",
        defensiveRanking: "Classement défensif",
      },
      actions: {
        addAllPicksAsParlay: "Ajouter tous les picks comme parlay",
        removeAll: "Tout retirer",
      },
    },
  },
};
